import firebase from "firebase";
import { removeGameFromUserFav } from "./gameActions";
export const removeFavorite = (uid, id) => async (dispatch) => {
  removeGameFromUserFav(id);
  firebase
    .firestore()
    .collection("users")
    .doc(uid)
    .update({
      my_favourites: firebase.firestore.FieldValue.arrayRemove(id),
    })
    .then((res) => {
      dispatch({
        type: "REMOVE _FAV",
      });
    });
};
